// Roles that may be put on a Legal Translation team. Translation experts
// (LegalTranslationProsecutor) come first; generic research prosecutors are
// still allowed so existing teams keep working.
export const TRANSLATION_EXPERT_ROLES: string[] = [
    "LegalTranslationProsecutor",
    "LegalResearchProsecutor",
];
